import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentShortInfoDto, DocumentType} from '../../../api/api-client';
import {DateTime} from 'luxon';
import {CardWithHeaderComponent} from '../card-with-header/card-with-header.component';
import {GreedyScrollPanelComponent} from '../greedy-scroll-panel/greedy-scroll-panel.component';
import {TranslationPipe} from '../../../pipes/translation.pipe';
import {ButtonModule} from 'primeng/button';
import {RippleModule} from 'primeng/ripple';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-document-list',
  imports: [
    CardWithHeaderComponent,
    GreedyScrollPanelComponent,
    TranslationPipe,
    ButtonModule,
    RippleModule,
    NgClass
  ],
  templateUrl: './document-list.component.html',
  styleUrl: './document-list.component.scss',
})
export class DocumentListComponent {

  @Input() pinnedDocuments: DocumentShortInfoDto[] = [];
  @Input() notPinnedDocuments: DocumentShortInfoDto[] = [];

  @Input() usedWithTabs: boolean = false
  @Input() hasHeader: boolean = true
  @Input() hasFooter:boolean = false
  @Input() pinnedTranslationKey:string ="DocumentList.Pinned"
  @Input() pinLock!: boolean;
  @Input() deletePinnedLock!: boolean;

  @Output() onPinDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onUnpinDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onDeleteDocument = new EventEmitter<DocumentShortInfoDto>();
  @Output() onViewDocument = new EventEmitter<string>();
  @Output() onAddDocument = new EventEmitter<DocumentType>();
  @Output() onEditDocument = new EventEmitter<DocumentShortInfoDto>();

  getDate(date: DateTime) {
    return date.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric'});
  }

  pinDocument(document: DocumentShortInfoDto) {
    this.onPinDocument.emit(document);
  }

  unpinDocument(document: DocumentShortInfoDto) {
    this.onUnpinDocument.emit(document);
  }

  openDeleteDocumentDialog(document: DocumentShortInfoDto) {
    this.onDeleteDocument.emit(document);
  }

  openViewDocumentDialog(documentId: string) {
    this.onViewDocument.emit(documentId);
  }

  openAddDocumentDialog(type: DocumentType) {
    this.onAddDocument.emit(type);
  }

  openEditDocumentPage(document: DocumentShortInfoDto) {
    this.onEditDocument.emit(document);
  }

}
